import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import _ from 'lodash';
import {
    POP_ROUTE,
    PUSH_ROUTE,
    REPLACE_ROUTE
} from './routesActions';
import { locationInfoByUrl, nonChildRoutes } from './Routes';

export default function reducer(state = {
    routes: [window.location.pathname]
}, action = {}) {
    let newState;

    switch (action.type) {
        case PUSH_ROUTE: {
            const newRoutes = state.routes.slice(0);
            newRoutes.push(action.route);

            newState = {
                ...state,
                routes: newRoutes
            };

            return _.isEqual(state, newState) ? state : newState;
        }

        case REPLACE_ROUTE: {
            const newRoutes = state.routes.slice(0);
            newRoutes.pop();
            newRoutes.push(action.route);

            newState = {
                ...state,
                routes: newRoutes
            };

            return _.isEqual(state, newState) ? state : newState;
        }

        case POP_ROUTE: {
            const newRoutes = state.routes.slice(0);
            newRoutes.pop();

            newState = {
                ...state,
                routes: newRoutes
            };

            return _.isEqual(state, newState) ? state : newState;
        }

        default:
            return state;
    }
}

export const getRoutesEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'routes')
);

export const getRoutes = createSelector(
    getRoutesEntity,
    (entity) => _.get(entity, 'routes')
);

export const getCanGoBack = createSelector(
    getRoutes,
    (routes) => routes.length > 1
);

export const getCurrentRoute = createSelector(
    getRoutes,
    (routes) => {
        const currentRoute = routes[routes.length - 1];

        return currentRoute ? currentRoute : window.location.pathname;
    }
);

export const getPreviousRoute = createSelector(
    getRoutes,
    (routes) => routes[routes.length - 2]
);

export const getGoBackTarget = createSelector(
    getCanGoBack,
    getCurrentRoute,
    getPreviousRoute,
    (canGoBack, currentRoute = '', previousRoute = '') => {
        if (canGoBack) {
            const currentLocationInfo = getLocationInfo(currentRoute);
            if (currentLocationInfo.fallback && !currentLocationInfo.fallback.noMatch) {
                return {
                    title: currentLocationInfo.fallback.title,
                    url: currentLocationInfo.fallback.url || 'goBack'
                };
            }
            const rerouteTarget = getRerouteTargetByLocation(previousRoute, true);
            const title = rerouteTarget.noMatch ? 'BACK' : rerouteTarget.title;

            return {
                title,
                url: 'goBack'
            };
        }

        return getRerouteTargetByLocation(currentRoute, false);
    }
);

export function getRerouteTargetByLocation(location = '', isPreviousLocation) {
    const locationInfo = getLocationInfo(location);

    return isPreviousLocation ? locationInfo : locationInfo.fallback;
}

export function getLocationInfo(location = '') {
    let locationInfo = _.find(locationInfoByUrl, (value) => {
        if (value.matcher) {
            return value.matcher.test(location);
        }
    });

    if (!locationInfo) {
        const locationKey = Object.keys(locationInfoByUrl)
            .find((matcher) => (location.startsWith(matcher) && matcher !== '/'));
        locationInfo = locationInfoByUrl[locationKey];
    }

    if (locationInfo) {
        return _.pick(locationInfo, ['title', 'fallback']);
    } else {
        return {
            fallback: {
                noMatch: true,
                title: 'NEXIO',
                url: '/'
            },
            noMatch: true,
            title: 'NEXIO',
            url: '/'
        };
    }
}

export const getCurrentLocationInfo = createSelector(
    getCurrentRoute,
    (currentRoute) => {
        return getLocationInfo(currentRoute);
    }
);

export const getCurrentLocationTitle = createSelector(
    getCurrentLocationInfo,
    (locationInfo) => (_.get(locationInfo, 'title', ''))
);

export const getIsCurrentRouteNavLinkRoute = createSelector(
    getCurrentRoute,
    (currentRoute) => {
        return nonChildRoutes.includes(currentRoute);
    }
);
